export const DEFAULT_LLM_MODEL = "claude-haiku-4-5-20251001";

export const SESSION_TIMEOUT_MS = 5 * 60 * 60 * 1000;

export const MARKETING_URLS = {
	officialWebsiteUrl: "https://www.illumi.one/",
	productUpdateUrl: "https://illumione.substack.com/notes",
	discordUrl: "https://discord.gg/cdfKN6CSMD",
	discordDefectsUrl: "https://discord.gg/ckR8MYzV5j",
	newsletterUrl: "https://illumione.substack.com/",
	youtubeUrl: "https://www.youtube.com/@illumione",
	linkedinUrl: "https://www.linkedin.com/company/illumione/posts/?feedView=all",
	contactUsUrl: "mailto: hello@illumi.one",
	bugReportFormUrl: "https://illumi.fibery.io/@public/forms/W1YC7klj",
	enterpriseContactUrl: "https://illumi.fibery.io/@public/forms/dM3gHTC9",
	userGuideUrl:
		"https://illumi.fibery.io/@public/User_Guide/Start-from-here-676 ",
	pricingPlanUrl: "https://illumi.one/pricing",
} as const;
